import React, {useEffect, useRef, useCallback, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {  RootReducer } from "../../../components/app/reducer"
import Disclaimer from "../../../components/disclaimer"
import { SelectCl } from "../../../components/select-cl"
import { fetchDepoCountries } from "../../../domains/depository/country/service"
import { fetchDepoCities } from "../../../domains/depository/city/service"
import { fetchDepoCodes } from "../../../domains/depository/code/service"
import { fetchDepoNames } from "../../../domains/depository/name/service"
import { fetchDepoTypes } from "../../../domains/depository/type/service"
import { fetchDepos } from "./service"
import ExplainDepositoryTypes from "../../../components/depo-search/explain-depo-types"
import { useHistory } from "react-router"

const DepositoryCriteria : React.FC = () => {
    
    const disclaimerAccepted = useSelector((state:RootReducer) =>  state.appReducer.blnAppDisclaimerAgreed );
    const allDomainsLoaded = useSelector(  (state:RootReducer) => {return state.depoCriteriaReducer.allDomainsLoaded });
    const criteriaError = useSelector( (state:RootReducer) => state.depoCriteriaReducer.error || state.depositoryReducer.error )    
    const state = useSelector( (state:RootReducer) => state.depoCriteriaReducer )
    const depoSearchDone = useSelector((state:RootReducer) =>  state.depositoryReducer.searchDone );
    const rootDispatch = useDispatch();
    const rootDispatchHistory = useDispatch();
    const formRef = useRef(null)
    const history = useHistory()
    const [reset, setReset] = useState(0);
    const[disableButton, setDisableButton] = useState(false);
    const[displayLoading, setDisplayLoading] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( () => {                
        if (criteriaError){
            setDisableButton(false);
            setDisplayLoading(false);
        } 
    })

    useEffect( ()=> {
        document.title = "Search for Depositories"
    },[])

    useEffect( () => {
        if ( ! allDomainsLoaded && ! displayLoading ){
            fetchDepoCountries( rootDispatch, "DepositoryCriteria")
            fetchDepoCities( rootDispatch, "DepositoryCriteria")
            fetchDepoCodes( rootDispatch, "DepositoryCriteria")
            fetchDepoNames( rootDispatch, "DepositoryCriteria")
            fetchDepoTypes( rootDispatch, "DepositoryCriteria")
        } else {
            //console.log("In CCB Criteria -> All domains loaded")
        }
    },[allDomainsLoaded, rootDispatch, displayLoading])

     /**
     * reset all the fields
     */
    const onReset = useCallback(() => {
        /*
        ["depoCode", "depoName", "depoCity", "depoCtry", "depoType"].forEach( (id) => {
           let inp = document.getElementById(id);
           if ( inp ) {
               let htmlInp: any = inp;
               htmlInp.value =  '---';
           }
        });
        */        
        rootDispatch ({ type: "Depository/FETCHERROR", payload: "" });
        setReset(reset + 1);
   },[reset]);

   const onSubmitHandle = useCallback(() => {
    if ( formRef.current !== null ) {
      const elmForm = formRef.current as unknown as HTMLFormElement;
      const data = new FormData( elmForm );
      setDisplayLoading(true);
      setDisableButton(true);
      fetchDepos(rootDispatch,rootDispatchHistory, data, window.history.state);
    }    
        return false;
    },[rootDispatch, rootDispatchHistory])

    useEffect( () => {
        if ( depoSearchDone ) {
            // push new history item == redirect to results page while maintaining the back button function
            history.push("/deporesults")
        }
        // clean-up immediately as without resetting the searchDone the nex render would be adding another history item
        return (()=> {rootDispatch({type:"Depository/RESETSEARCH"})})
    }, [depoSearchDone, history, rootDispatch])

    return (
        <div id="depository-criteria">
                {/* Disclaimer will not render (retruns null) if accepted */}
                <Disclaimer/>                 
                { disclaimerAccepted && (! allDomainsLoaded  || displayLoading ) && ( <> <span>LOADING...</span>   </>) }
                { disclaimerAccepted && criteriaError && ( 
                    <div> 
                        <ul >
                            <li className="codelist-header bold">{criteriaError}</li>
                        </ul>
                    </div>) 
                }
                { ! displayLoading && disclaimerAccepted && allDomainsLoaded && (
                    <form ref={formRef} onSubmit={(e) => { e.preventDefault(); //onSubmitHandle(e)   
                        } }>
                        <p className="codelist-header">Depositories Database</p>
    
                        <div className="search-header-info">
                            <p>Please enter your search criteria in the fields below.</p>  
                            <p>
                                <span className="bold">Download facilities are available on the next pages.</span>
                            </p>
                        </div>
                        <div className="search-control">
                                <span><button disabled = {disableButton} onClick={ onSubmitHandle }>Search</button></span>                                     
                                <span><button disabled = {disableButton} onClick={ onReset }>Reset</button></span>
                        </div>                        
    
                        { (
                            <div className="search-table">
                                <SelectCl 
                                    id="depoCode" 
                                    label="Depository Code : "
                                    name="code"
                                    options={state.depoCodes}
                                    reset={reset} />
                                <SelectCl
                                    id="depoName"
                                    label="Depository Name : "
                                    name="name"
                                    options={state.depoNames}
                                    reset={reset} />
                                <SelectCl
                                    id="depoCity"
                                    label="Depository City : "
                                    name="city"
                                    options={state.cities}
                                    reset={reset} />
                                <SelectCl
                                    id="depoCtry"
                                    label="Depository Country : "
                                    name="ctry"
                                    options={state.countries}
                                    reset={reset} />
                                <SelectCl
                                    id="depoType"
                                    label="Depository Type: "
                                    name="type"
                                    options={state.depoTypes} 
                                    explain={ <ExplainDepositoryTypes locationURL={window.location.protocol +"//" +  window.location.hostname + ":" + window.location.port}/> }
                                    reset={reset}/>                                     
                            </div>
                        )}
                        </form>
                )}
                
        </div>

			
    )

}


export default DepositoryCriteria
